module.exports = __webpack_public_path__ + "img/TO.e6b8e7fb.svg";